<style>
</style>

<template>
  <div>
    <div class="m_tb_box m_tran50">
      <mt-header :title="title">
        <a @click="$router.go(-1)" slot="left">
          <mt-button icon="back">返回</mt-button>
        </a>
      </mt-header>
      <div v-if="titleArr.length>1">
        <table width="100%" class="m_tb_1" border="0" cellspacing="0" cellpadding="0">
          <tr class="m_tr_1">
            <td
              class="m_td_1"
              :class="currentIndex==index?'active': ''"
              @click="jump('jump'+index,index)"
              v-for="(item,index) in titleArr"
              :key="index"
            >
              <div class="m_aText textLine">{{item}}</div>
              <div :class="currentIndex==index?'m_arrow': 'm_arrow_2'"></div>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="down_info m_tran50">{{doc}}</div>
  </div>
</template>

<script>
import { getArticleById } from '@/api/api'
export default {
  data () {
    return {
      doc: '',
      title: '无命题',
      titleArr: [],
      currentIndex: 0,
      baifen: '',
      baifen2: '',
      listLength: -1,
      isFirst: false,
      timer: false,
      clientHeight: 0,
      scrollTop: 0,
      scrollHeight: 0
    }
  },
  created () {
    getArticleById(this.$route.query.id).then(res => {
      var down_info = document.querySelector('.down_info')
      down_info.innerHTML = res.data.body
      this.title = res.data.title
      setTimeout(() => {
        var h2s = document.querySelectorAll('h2')
        this.listLength = h2s.length
        if (h2s.length < 2) {
          return
        }
        for (var i = 0; i < h2s.length; i++) {
          h2s[i].id = 'jump' + i
          this.titleArr.push(h2s[i].innerHTML)
        }
        setTimeout(() => {
          window.onscroll = e => {
            this.touchTag(h2s)
          }

          var tds = document.querySelectorAll('.m_td_1')
          for (var i = 0; i < tds.length; i++) {
            if (tds.length <= 4) {
              document.querySelector('.m_tr_1').style.overflowX = 'hidden'
              tds[i].style.width = 25.14 / h2s.length + 'rem'
              tds[i].style.paddingLeft = '1.285rem'
            } else {
              tds[i].style.width = '6.285rem'
              tds[i].style.paddingLeft = '1.285rem'
            }
          }
        }, 10)
      }, 10)
    })
  },
  methods: {
    touchTag (h2s) {
      if (this.timer == false) {
        for (var i = 0; i < h2s.length - 1; i++) {
          var tempi = i
          this.clientHeight = document.documentElement.clientHeight
          this.scrollTop = document.documentElement.scrollTop
          this.scrollHeight = document.documentElement.scrollHeight
          console.log(document.documentElement.scrollTop)
          if (
            this.scrollTop + 115 > $('#jump' + tempi).offset().top &&
            this.scrollTop + 115 < $('#jump' + (tempi + 1)).offset().top
          ) {
            // if(i>=4){
            console.log($('#jump' + tempi).offset().top + '----' + i)
            //    document.querySelector('.m_tr_1').scrollLeft +=88;

            // }else{
            //   document.querySelector('.m_tr_1').scrollLeft -=88;
            // }

            if (this.listLength > 4) { document.querySelector('.m_tr_1').scrollLeft = 88 * (i - 2) }
            this.currentIndex = i

            break
            //
          } else if (
            this.scrollTop + 85 > $('#jump' + (h2s.length - 1)).offset().top ||
            this.scrollHeight - 30 <= this.scrollTop + this.clientHeight
          ) {
            if (this.listLength > 4) {
              document.querySelector('.m_tr_1').scrollLeft =
                88 * (h2s.length - 1)
            }
            this.currentIndex = h2s.length - 1
            break
          }
        }
      }
    },
    jump (id, index) {
      if (this.listLength > 4) { document.querySelector('.m_tr_1').scrollLeft = 88 * index }

      this.timer = true
      console.log(this.timer)
      setTimeout(() => {
        this.timer = false
      }, 500)
      this.currentIndex = index
      $('html, body').animate(
        {
          scrollTop: $('#' + id).offset().top - 95
        },
        { duration: 200, easing: 'swing' }
      )
      return false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tutorialDownInfo.vue